import { useAtomValue } from "jotai";
import React from "react";

import { UserRole, userAtom } from "../../hooks/atoms";

interface Props {
  children: JSX.Element;
  privileges: UserRole[];
  fallback?: React.ReactNode;
  bypass?: boolean;
}

const RequirePrivilege: React.FC<Props> = ({
  children,
  privileges,
  fallback,
  bypass,
}) => {
  const user = useAtomValue(userAtom);
  return bypass || (user?.role && privileges.includes(user.role))
    ? children
    : (fallback ?? null);
};

export default RequirePrivilege;
